// React
import { useContext } from "react"

// Components
import { Button, Input, Modal } from "components"
import { DetailBill } from "../../EnterBill/components"

// Contexts
import { DataContext } from "../contexts"

// Icons
import { TbInfoCircle } from "react-icons/tb"

// Utils
import { useToggle } from "utils"

export function LinkBill(): JSX.Element {
  // Hooks
  const { data } = useContext(DataContext)

  return (
    <section className="flex items-end">
      <section className="grow">
        <Input
          disabled
          inputClass="rounded-r-none"
          label="LINK TO DELIVERY BILL ID"
          value={data.trx_code}
        />
      </section>

      <DetailSection />
    </section>
  )
}

function DetailSection(): JSX.Element {
  // Hooks
  const { data } = useContext(DataContext)
  const { isActive, toggle } = useToggle(false)

  return (
    <>
      <Button
        type="button"
        color="primary"
        onClick={toggle}
      >
        <TbInfoCircle />
      </Button>

      {isActive && (
        <Modal
          isOpen
          title="PURCHASE ORDER DETAIL"
          closeModal={toggle}
        >
          <Modal.Body>
            <DetailBill
              bill_id={data.bill_id}
              purchase_order_id={data.purchase_order_id}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}